import * as React from 'react'

import * as moment from 'moment'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form'

import { databaseRef } from 'config/firebase'

import * as PatientActions from 'store/patients/actions'
import * as UserActions from 'store/user/actions'

import Content from './content'

import SnackbarService from '../../services/snackbars'

import { _route } from '../../routes/config'

import { CropImage } from 'components'

import './style.scss'

interface IProps extends InjectedFormProps {
  UserLib?: any
  PatientsLib?: any
  patientDetails: any
  educatorDetails: any
  history?: any
  user?: any
}

interface IState {
  typeOfForm: string
  page: string
  croppedImage?: any
  image: any
  isPhotoValid: boolean
  careProfessional: { id_care_professional: any }
  loading: boolean
}

class AddPatient extends React.Component<IProps, IState> {
  state = {
    typeOfForm: 'patient',
    page: 'form',
    image: null,
    isPhotoValid: false,
    croppedImage: null,
    careProfessional: { id_care_professional: 0 },
    loading: false
  }

  onSubmitPressed = false

  componentDidMount() {
    this.getCareProfessional()
  }

  getCareProfessional = () => {
    const errorAction = e => {
      console.log(e)
      SnackbarService.showSnackbar(
        'Something went wrong. Please try again later',
        'error'
      )
      this.props.history.push(_route.patient.list)
    }

    try {
      const {
        history: {
          location: {
            state: { careProfessionalEmail }
          }
        }
      } = this.props

      databaseRef
        .child('care_professionals')
        .orderByChild('email')
        .equalTo(careProfessionalEmail)
        .once('value')
        .then(snapshot => {
          const res = snapshot.val()

          if (res) {
            const resArray = Object.keys(res).map(i => {
              res[i].patientId = i
              return res[i]
            })

            const careProfessional = resArray.find(
              item => item.email === careProfessionalEmail
            )
            if (!careProfessional) {
              errorAction('no care proffessional')
              return
            }
            this.setState({ careProfessional })
          } else {
            errorAction('no care proffessional')
            return
          }
        })
        .catch(error => {
          errorAction(error)
        })
    } catch (e) {
      errorAction(e)
    }
  }

  changeTypeOfForm = async typeOfForm => {
    this.setState({ typeOfForm })
  }

  savePhoto = () => {
    const { valid } = this.props
    const { croppedImage, loading } = this.state

    if (loading) {
      return
    }

    if (!valid) {
      SnackbarService.showSnackbar(
        'Something went wrong. Please try again later',
        'error'
      )
      return
    }

    if (croppedImage) {
      this.props.PatientsLib.uploadImage(
        croppedImage,
        this.onSubmit,
        message => {
          SnackbarService.showSnackbar(message, 'error')
        }
      )
    } else {
      this.onSubmit('')
    }
  }

  onSubmit = async avatarUrl => {
    const { patientDetails, educatorDetails } = this.props
    const { careProfessional, typeOfForm, loading } = this.state

    if (this.onSubmitPressed) {
      return
    }

    this.onSubmitPressed = true

    if (typeOfForm === 'educator') {
      if (educatorDetails.educatorEmail === patientDetails.parentEmail) {
        SnackbarService.showSnackbar(
          `Educator Email can't be the same as Parent Email, please use another one`,
          'error'
        )
        return
      }
    }

    if (loading) {
      return
    }

    this.setState({ loading: true }, () => {
      const patientData = {
        id_care_professional: careProfessional.id_care_professional,
        birth_date: moment(patientDetails.dateOfBirth).unix(),
        gender: patientDetails.gender,
        name: patientDetails.full_name,
        patient_avatar: avatarUrl,
        source: 'CP'
      }

      const parentData = {
        email: patientDetails.parentEmail,
        name: patientDetails.parentContact,
        phone: patientDetails.parentPhone
      }

      const educatorData = {
        email: educatorDetails.educatorEmail,
        name: educatorDetails.educatorFullName,
        phone_number: educatorDetails.phone,
        education_institute: educatorDetails.school
      }

      this.props.PatientsLib.savePatient(
        patientData,
        parentData,
        educatorData,
        children => {
          this.props.UserLib.signInWithoutPassword(
            patientDetails.parentEmail,
            'parent',
            {
              fullName: patientDetails.fullName,
              children
            },
            () => {
              this.props.UserLib.signInWithoutPassword(
                educatorDetails.educatorEmail,
                'educator',
                { fullName: educatorDetails.educatorFullName },
                () => {
                  SnackbarService.showSnackbar(
                    'The patient has been successfully added',
                    'success'
                  )
                  this.props.history.push('/add_done', {
                    userName: patientDetails.fullName,
                    parentEmail: patientDetails.parentEmail,
                    educatorEmail: educatorDetails.educatorEmail
                  })
                },
                errorMessage => {
                  SnackbarService.showSnackbar(errorMessage, 'error')
                  this.onSubmitPressed = false
                  setTimeout(() => this.setState({ loading: false }), 1000)
                }
              )
            },
            errorMessage => {
              SnackbarService.showSnackbar(errorMessage, 'error')
              this.onSubmitPressed = false
              setTimeout(() => this.setState({ loading: false }), 1000)
            }
          )
        }
      )
    })
  }

  handleFiles = ({ base64 }) => {
    const { page } = this.state

    if (page === 'form' && base64.includes('image')) {
      this.setState({ page: 'crop-avatar', image: base64 })
    }
  }

  onSubmitCrop = image => {
    this.setState({ page: 'form', croppedImage: image, isPhotoValid: true })
  }

  onCancelCrop = () => {
    this.setState({ page: 'form' })
  }

  onChangeMaskedInput = (name: string, value: string) => {
    this.props.change(name, value)
  }

  onChangeRadio = (name: string, value: string) => {
    this.props.change(name, value)
  }

  render() {
    const { typeOfForm, page, image, isPhotoValid, loading } = this.state
    const { valid } = this.props

    return (
      <React.Fragment>
        {page === 'crop-avatar' ? (
          <CropImage
            onSubmit={this.onSubmitCrop}
            onCancel={this.onCancelCrop}
            image={image}
          />
        ) : (
          <Content
            typeOfForm={typeOfForm}
            changeTypeOfForm={this.changeTypeOfForm}
            isValidForm={valid}
            isPhotoValid={isPhotoValid}
            onSubmit={this.savePhoto}
            image={image}
            handleFiles={this.handleFiles}
            onChangeMaskedInput={this.onChangeMaskedInput}
            onChangeRadio={this.onChangeRadio}
            loading={loading}
          />
        )}
      </React.Fragment>
    )
  }
}

const AddPatientContainer = reduxForm({
  form: 'addPatient'
})(AddPatient)

const selector = formValueSelector('addPatient')

const mapStateToProps = state => {
  const patientDetails = {
    fullName: selector(state, 'fullName') || '',
    dateOfBirth: selector(state, 'dateOfBirth') || '',
    gender: selector(state, 'gender') || '',
    parentContact: selector(state, 'parentContact') || '',
    parentPhone: selector(state, 'parentPhone') || '',
    parentEmail: selector(state, 'parentEmail') || ''
  }

  const educatorDetails = {
    educatorFullName: selector(state, 'educatorFullName') || '',
    educatorEmail: selector(state, 'educatorEmail') || '',
    school: selector(state, 'school') || '',
    phone: selector(state, 'phone') || ''
  }

  return {
    ...patientDetails,
    ...educatorDetails,
    patientDetails,
    educatorDetails,
    user: state.user.data
  }
}

const mapDispatchToProps = dispatch => {
  return {
    UserLib: bindActionCreators<any, any>(UserActions, dispatch),
    PatientsLib: bindActionCreators(PatientActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddPatientContainer)



// WEBPACK FOOTER //
// ./src/pages/AddPatient/index.tsx